import { Stack, Text } from "@mantine/core";

import { SeoOpeningTagline } from "./SeoCommon";
import { SeoFooter } from "./SeoFooter";
import { SeoSection } from "./SeoSection";

export const InibuildsA300Seo = (): JSX.Element => {
  return (
    <Stack>
      <SeoSection title="Master the A300">
        <Text fz="medium">
          The iniBuilds A300 is a faithful simulation of the classic A300 airliner for both
          passenger and cargo ops. Its in-depth systems are true-to-life, which can make everyday
          flying a challenge if you don't have a type rating. <SeoOpeningTagline />
        </Text>
      </SeoSection>
      <SeoSection>
        <Text fz="medium">
          Start with our A300 checklist and make it your own using the web-based editor. Expand the
          checklist with your own flows and memory items, or choose from a library of popular addons
          to help you remember to file your flight plan with ATC, or remove the chocks before
          pushback. When you're ready to fly, export your checklist as a PDF. Checklists can be
          exported and shared with a friend or first officer, and are saved in your browser, so you
          can come back and change them later.
        </Text>
        <SeoFooter />
      </SeoSection>
    </Stack>
  );
};
